import { ref } from 'vue'

const current = ref(null)
let hideTimer = null

export const useNotification = () => {
  const show = (message, type = 'info', timeout = 3500) => {
    current.value = { message, type }
    if (hideTimer) clearTimeout(hideTimer)
    if (timeout > 0) {
      hideTimer = setTimeout(() => {
        current.value = null
        hideTimer = null
      }, timeout)
    }
  }

  const hide = () => {
    current.value = null
    if (hideTimer) {
      clearTimeout(hideTimer)
      hideTimer = null
    }
  }

  return {
    current,
    show,
    hide
  }
}
